/** Utilities methods used for this project
 *
 */

/** Try to load component form customer's folder, if is missing, load standard component
 * @param componentPath
 * @return {Promise<any>}
 */
export let customImport = componentPath => {
    return new Promise((resolve, reject) => {
        import("@custom/" + componentPath)
            .then(module => {
                resolve(module);
            })
            .catch(missingErr => {
                if (missingErr.toString().match(/Cannot find module/gi) === null) console.error(missingErr);
                import("@configurator/" + componentPath)
                    .then(module => {
                        resolve(module);
                    })
                    .catch(err => {
                        console.error(missingErr);
                        reject(err);
                    });
            });
    });
};

/** Try to load dialog from customer's folder, if missing, load standard dialog (modal)
 *
 * @param componentPath
 * @return {*}
 */
export let customDialogsImport = componentPath => {
    let dialog;
    try {
        dialog = require("@custom/dialogs/" + componentPath).default;
    } catch (missingErr) {
        if (missingErr.toString().match(/Cannot find module/gi) === null) console.error(missingErr);

        dialog = require("@dialogs/" + componentPath).default;
    }

    return dialog;
};

export let downloadJSON = (json, filename = "untitled") => {
    if (!filename || filename.length < 1) filename = "untitled";

    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    let jsonStr = JSON.stringify(json, null, 4);
    let blob = new Blob([jsonStr], { type: "octet/stream" });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename + ".json";
    a.click();
    window.URL.revokeObjectURL(url);
};



// WEBPACK FOOTER //
// ./src/utils.js